import React, { useState } from "react";
import { PayrollClient } from "services";
import {
  Button,
  Col,
  Label,
  Input,
} from "reactstrap";
import moment from 'moment';
import { Trans } from "react-i18next";
import { LocalForm } from "react-redux-form";
import { NotificationManager } from "react-notifications";

const AddAttendance = ({ t, employee }) => {
  const [timeForm, setTimeForm] = useState({})
  const payroll = PayrollClient();
  const [pending, setPending] = useState(false);

  const updateAttendance = () => {
    setPending(true)
    try {
      payroll
        .post(`attendance_report/bulk_edit`, [timeForm])
        .then(({ data }) => {
          setTimeForm({})
          NotificationManager.success(t("Updated successfully"));
        })
    } catch (err) {
      NotificationManager.error(t('Error while Update'));
    } finally {
      setPending(false)
    }
  };

  return (
    <div>
      <LocalForm onSubmit={updateAttendance}>
        <Col className="col-md-12 col-xs-12 mb-3">
          <Label htmlFor="time date"><Trans>Date Value</Trans></Label>
          <Input className="my-3"
            type="date"
            name="time_date"
            placeholder="e.g. 2024-04-29"
            value={timeForm?.time_date || ""}
            max={moment().format("YYYY-MM-DD")}
            onChange={(e) => setTimeForm(
              { ...timeForm, time_date: e.target.value }
            )} 
            required/>
          <Label htmlFor="time in"><Trans>Time In Value</Trans></Label>
          <Input className="my-3" type="time"
            name="time_in"
            placeholder="e.g. 08:00:00"
            value={timeForm?.time_in || ""}
            onChange={(e) => setTimeForm(
              { ...timeForm, time_in: e.target.value, employee: employee.id }
            )} 
            required/>
          <Label htmlFor="time out"><Trans>Time Out Value</Trans></Label>
          <Input type="time"
            name="time out"
            placeholder="e.g. 12:00:00"
            value={timeForm?.time_out || ""}
            onChange={(e) => setTimeForm({ ...timeForm, time_out: e.target.value })} 
            required/>
          <Button
            style={{ marginBottom: "10px" }}
            color="success"
            className="bt float-right mt-4 mx-0"
            type="submit"
            disabled={pending}
            >
            {pending && <span className="fa fa-fw fa-spin fa-spinner mr-1" />}<Trans>Add</Trans>
          </Button>
        </Col>
      </LocalForm>
    </div>
  );
};

export default AddAttendance;